module.exports = __webpack_public_path__ + "img/icon-check-mark.d05ef767.svg";